import actions from '../../actionTypes';

export default () => {
  try {
    return {
      type: actions.CLEAR_INVITE_LINK
    };
  } catch (err) { }
};



// WEBPACK FOOTER //
// ./src/reducers/users/actions/clearInviteLink.js